const keyDataArray = [
  { key: 'Verbatim', checked: true, title: 'Verbatim' },
  { key: 'KeywordValue', checked: true, title: 'Keyword' },
  { key: 'SubKeywordLevel1', checked: false, title: 'Sub Keyword Level 1' },
  { key: 'SubKeywordLevel2', checked: false, title: 'Sub Keyword Level 2' },
  { key: 'Vibe', checked: true, title: 'Vibe' },
  { key: 'Notes', checked: true, title: 'Notes' },
  { key: 'KeywordType', checked: true, title: 'Type' },
  { key: 'KeywordSubType', checked: false, title: 'Sub Type' },
  { key: 'Question1Value', checked: false, title: 'Question 1' },
  { key: 'Question2Value', checked: false, title: 'Question 2' },
  { key: 'Question3Value', checked: false, title: 'Question 3' },
  { key: 'Question4Value', checked: false, title: 'Question 4' },
  { key: 'Question5Value', checked: false, title: 'Question 5' },
  { key: 'Question6Value', checked: false, title: 'Question 6' },
  { key: 'Question7Value', checked: false, title: 'Question 7' },
  { key: 'Question8Value', checked: false, title: 'Question 8' },
  { key: 'Question9Value', checked: false, title: 'Question 9' },
  { key: 'Question10Value', checked: false, title: 'Question 10' },
  { key: 'Question11Value', checked: false, title: 'Question 11' },
  { key: 'Question12Value', checked: false, title: 'Question 12' },
  { key: 'Question13Value', checked: false, title: 'Question 13' },
  { key: 'Question14Value', checked: false, title: 'Question 14' },
  { key: 'Question15Value', checked: false, title: 'Question 15' },
  { key: 'QuestionMulti1Value', checked: false, title: 'Question Multi 1' },
  { key: 'QuestionMulti2Value', checked: false, title: 'Question Multi 2' },
  { key: 'UserGlobalQuestion1Value', checked: false, title: 'User Global Question 1' },
  { key: 'UserGlobalQuestion2Value', checked: false, title: 'User Global Question 2' },
  { key: 'UserLocalQuestion1Value', checked: false, title: 'User Local Question 1' },
  { key: 'UserLocalQuestion2Value', checked: false, title: 'User Local Question 2' },
  { key: 'UserLocalQuestion3Value', checked: false, title: 'User Local Question 3' },
  { key: 'UserLocalQuestion4Value', checked: false, title: 'User Local Question 4' },
  { key: 'UserLocalQuestion5Value', checked: false, title: 'User Local Question 5' },
  { key: 'UserLocalQuestion6Value', checked: false, title: 'User Local Question 6' },
  { key: 'UserLocalQuestion7Value', checked: false, title: 'User Local Question 7' },
  { key: 'UserLocalQuestion8Value', checked: false, title: 'User Local Question 8' },
  { key: 'UserLocalQuestion9Value', checked: false, title: 'User Local Question 9' },
  { key: 'UserLocalQuestion10Value', checked: false, title: 'User Local Question 10' },
  { key: 'UserLocalQuestion11Value', checked: false, title: 'User Local Question 11' },
  { key: 'UserLocalQuestion12Value', checked: false, title: 'User Local Question 12' },
  { key: 'StartItemDatePeriod', checked: false, title: 'Start Item Date Period' },
  { key: 'EndItemDatePeriod', checked: false, title: 'End Item Date Period' },
  { key: 'Gender', checked: false, title: 'Gender' },
  { key: 'MaxAge', checked: false, title: 'Max Age' },
  { key: 'MinAge', checked: false, title: 'Min Age' },
  { key: 'LocationCountry', checked: false, title: 'Country' },
  { key: 'LocationState', checked: false, title: 'State' },
  { key: 'LocationCity', checked: false, title: 'City' },
  { key: 'MaxVerbatimUsedCount', checked: false, title: 'Max Verbatim Used Count' },
  { key: 'EditedBy', checked: false, title: 'Edited By' },
  { key: 'CheckedBy', checked: false, title: 'Analysed By' },
  { key: 'RecheckedBy', checked: false, title: 'Reanalysed By' },
  { key: 'QCBy', checked: false, title: 'QC By' },
  { key: 'QCNotBy', checked: false, title: 'QC Not By' },
  { key: 'OrganizationName', checked: false, title: 'Filter By Organization Name' },
  { key: 'AggregationItemId', checked: false, title: 'Item Id' }
]

export default keyDataArray
